import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { AvatarProfileImageFragmentDoc } from '../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SelectUsersDialog_UsersQueryVariables = Types.Exact<{
  input: Types.GetPeopleInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type SelectUsersDialog_UsersQuery = { __typename?: 'Query', People: { __typename?: 'Employees', totalCount: number, objects: Array<{ __typename?: 'Employee', id: number, name: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null, locations: Array<{ __typename?: 'Location', id: number, name: string }>, roles: Array<{ __typename?: 'Role', id: number, name: string }> }> } };

export type SelectUsersDialog_UserThinFragment = { __typename?: 'Employee', id: number, name: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null, locations: Array<{ __typename?: 'Location', id: number, name: string }>, roles: Array<{ __typename?: 'Role', id: number, name: string }> };

export type SelectUsersDialog_LocationGroupsQueryVariables = Types.Exact<{
  type: Types.LocationGroupType;
}>;


export type SelectUsersDialog_LocationGroupsQuery = { __typename?: 'Query', LocationGroups: { __typename?: 'LocationGroups', objects: Array<{ __typename?: 'LocationGroup', id: string, name: string }> } };

export type SelectUsersDialog_LocationGroupFragment = { __typename?: 'LocationGroup', id: string, name: string };

export const SelectUsersDialog_UserThinFragmentDoc = gql`
    fragment SelectUsersDialog_UserThin on Employee {
  id
  name
  profileImage {
    ...AvatarProfileImage
  }
  locations {
    id
    name
  }
  roles {
    id
    name
  }
}
    ${AvatarProfileImageFragmentDoc}`;
export const SelectUsersDialog_LocationGroupFragmentDoc = gql`
    fragment SelectUsersDialog_LocationGroup on LocationGroup {
  id
  name
}
    `;
export const SelectUsersDialog_UsersDocument = gql`
    query SelectUsersDialog_Users($input: GetPeopleInput!, $pagination: PaginationInput) {
  People(input: $input, pagination: $pagination) {
    totalCount
    objects {
      ...SelectUsersDialog_UserThin
    }
  }
}
    ${SelectUsersDialog_UserThinFragmentDoc}`;

/**
 * __useSelectUsersDialog_UsersQuery__
 *
 * To run a query within a React component, call `useSelectUsersDialog_UsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectUsersDialog_UsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectUsersDialog_UsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSelectUsersDialog_UsersQuery(baseOptions: Apollo.QueryHookOptions<SelectUsersDialog_UsersQuery, SelectUsersDialog_UsersQueryVariables> & ({ variables: SelectUsersDialog_UsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectUsersDialog_UsersQuery, SelectUsersDialog_UsersQueryVariables>(SelectUsersDialog_UsersDocument, options);
      }
export function useSelectUsersDialog_UsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectUsersDialog_UsersQuery, SelectUsersDialog_UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectUsersDialog_UsersQuery, SelectUsersDialog_UsersQueryVariables>(SelectUsersDialog_UsersDocument, options);
        }
export type SelectUsersDialog_UsersQueryHookResult = ReturnType<typeof useSelectUsersDialog_UsersQuery>;
export type SelectUsersDialog_UsersLazyQueryHookResult = ReturnType<typeof useSelectUsersDialog_UsersLazyQuery>;
export type SelectUsersDialog_UsersQueryResult = Apollo.QueryResult<SelectUsersDialog_UsersQuery, SelectUsersDialog_UsersQueryVariables>;
export const SelectUsersDialog_LocationGroupsDocument = gql`
    query SelectUsersDialog_LocationGroups($type: LocationGroupType!) {
  LocationGroups(input: {types: [$type]}) {
    objects {
      ...SelectUsersDialog_LocationGroup
    }
  }
}
    ${SelectUsersDialog_LocationGroupFragmentDoc}`;

/**
 * __useSelectUsersDialog_LocationGroupsQuery__
 *
 * To run a query within a React component, call `useSelectUsersDialog_LocationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectUsersDialog_LocationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectUsersDialog_LocationGroupsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSelectUsersDialog_LocationGroupsQuery(baseOptions: Apollo.QueryHookOptions<SelectUsersDialog_LocationGroupsQuery, SelectUsersDialog_LocationGroupsQueryVariables> & ({ variables: SelectUsersDialog_LocationGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectUsersDialog_LocationGroupsQuery, SelectUsersDialog_LocationGroupsQueryVariables>(SelectUsersDialog_LocationGroupsDocument, options);
      }
export function useSelectUsersDialog_LocationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectUsersDialog_LocationGroupsQuery, SelectUsersDialog_LocationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectUsersDialog_LocationGroupsQuery, SelectUsersDialog_LocationGroupsQueryVariables>(SelectUsersDialog_LocationGroupsDocument, options);
        }
export type SelectUsersDialog_LocationGroupsQueryHookResult = ReturnType<typeof useSelectUsersDialog_LocationGroupsQuery>;
export type SelectUsersDialog_LocationGroupsLazyQueryHookResult = ReturnType<typeof useSelectUsersDialog_LocationGroupsLazyQuery>;
export type SelectUsersDialog_LocationGroupsQueryResult = Apollo.QueryResult<SelectUsersDialog_LocationGroupsQuery, SelectUsersDialog_LocationGroupsQueryVariables>;